import { render, staticRenderFns } from "./RequestedEmployees.vue?vue&type=template&id=01d82d87&"
import script from "./RequestedEmployees.vue?vue&type=script&lang=js&"
export * from "./RequestedEmployees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports